<!--
 * @FileDescription: 附件标签页
 * @Author: fanqixin
 * @Date: 2021-8-4 10:58:27
 * @LastEditors: fanqixin
 * @LastEditTime: 2021-8-4 10:58:27
 -->
<template>
	<div class="attachments-viewer">
		<!-- 按钮栏 -->
		<el-row type="flex" class="margin-bottom-sm" :justify="buttonPosition" v-if="editable">
			<el-form :inline="true" @submit.native.prevent v-if="editable" size="small">
				<el-form-item class="text-red" v-if="buttonPosition === 'end'">{{ message }}</el-form-item>
				<el-form-item>
          <slot name="button"></slot>
          <!--    占位用      -->
					<el-button type="info" class="custom-btn" stopCountDown icon="el-icon-upload2" v-if="customBtn != null && customBtn.length > 0" :class="buttonPosition == 'end' ? 'custom-btn-end' : ''">{{customBtn}}</el-button>
					<el-button type="primary" icon="el-icon-upload2" @click="handleUpload">上传附件</el-button>
					<el-button type="danger" icon="el-icon-delete" @click="handleDeleteRows">删除附件</el-button>
				</el-form-item>
				<el-form-item class="text-red" v-if="buttonPosition !== 'end'">{{ message }}</el-form-item>
			</el-form>
		</el-row>
		<!-- 附件信息表格 -->
		<el-table
			ref="multipleTable"
			:style="{ 'min-height': height + 'px', 'margin-top': top + 'px' }"
			:data="dataList"
			:loading="loading"
			:row-class-name="tableRowClassName"
			@row-click="handleRowClick"
			@selection-change="handleSelectionChange"
			stripe
			border
		>
			<el-table-column type="selection" width="50" align="center"></el-table-column>
			<el-table-column type="index" label="序号" width="64" align="center"></el-table-column>
			<el-table-column prop="ylcFile.fileName" label="文件名称" min-width="235">
				<template slot-scope="scope">
					<span class="el-text--primary" @click.stop="handlePreview(scope.row.ylcFile)">{{ scope.row.ylcFile.fileName }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="ylcFile.creationName" label="创建人" min-width="140"></el-table-column>
			<el-table-column prop="ylcFile.creationDate" label="上传时间" min-width="160" :formatter="formatDate"></el-table-column>
			<el-table-column prop="ylcFile.fileSize" label="文件大小" min-width="120" :formatter="formatFileSize"></el-table-column>
			<el-table-column label="操作" min-width="100" align="center">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" icon="el-icon-download" @click.stop="handleDownload(scope.row.ylcFile)" v-if="scope.row.ylcFile.id != null">
						下&nbsp;载
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 文件上传弹窗 -->
		<file-uploader ref="fileUploader" :sourceType="sourceType" :maxSize="maxSize" @confirm="handleAddFiles"></file-uploader>
		<!-- 附件预览弹窗 -->
		<el-dialog :visible.sync="previewDialog.visible" :append-to-body="true">
			<el-image :src="previewDialog.filePath" fit="contain" v-if="previewDialog.fileType === 'image'">
				<div slot="error" class="image-slot text-xsl"><i class="el-icon-picture-outline"></i></div>
			</el-image>
			<iframe :src="previewDialog.filePath" scrolling="auto" frameborder="0" v-else></iframe>
		</el-dialog>
	</div>
</template>

<script>
import { getAttachments, download } from '@/api/attachment';
import { formatDate, formatFileSize, isTypeof, isEmpty, getFileType } from '@/utils';
import fileUploader from './file-uploader.vue';

export default {
	name: 'attachments-viewer',
	components: {
		fileUploader: fileUploader
	},
	props: {
		// 距离顶部距离
		top: {
			type: String,
			default: '0'
		},
		// 表格高度
		height: {
			type: String,
			default: '364'
		},
		// 可否编辑
		editable: {
			type: Boolean,
			default: false
		},
		// 是否必填
		required: {
			type: Boolean,
			default: false
		},
		// 最多数量
		max: {
			type: Number,
			default: 100
		},
		// 文件最大大小
		maxSize: {
			type: Number,
			default: 20
		},
		// 按钮位置
		buttonPosition: {
			type: String,
			default: 'end'
		},
		customBtn: {
			type: String,
			default: ''
		},
		// 提示
		message: {
			type: String,
			default: ''
		},
		// 数据类型范围
		sourceType: {
			type: [Array, String],
			default: () => {
				return ['video', 'audio', 'image', 'word', 'excel', 'ppt', 'pdf', 'txt'];
			}
		}
	},
	data() {
		return {
			isLoaded: false, // 是否已加载
			dataList: [], // 清单数据
			removed: [], // 删除数据
			multipleSelection: [], // 选中项
			loading: false, // 是否局部加载
			preventDownload: '', // 阻止重复下载
			// 预览弹窗
			previewDialog: {
				visible: false, // 弹窗是否显示
				fileType: '', // 文件类型
				filePath: '' // 文件预览地址
			}
		};
	},
	// 页面创建后
	created() {},
	methods: {
    formatDate: (row, column, cellValue) => formatDate(cellValue),
    formatFileSize: (row, column, cellValue) => formatFileSize(cellValue),
		/**
		 * @description: 根据id获取清单数据
		 * @param {String} model 单据id/附件清单
		 * @param {Boolean} loading 是否局部加载
		 */
		load(model, loading) {
			if (isEmpty(model) || this.isLoaded) {
				return;
			}
			if (Array.isArray(model)) {
				this.isLoaded = true;
				this.dataList = model;
			} else {
				this.getDetailList(model, loading);
			}
		},
		/**
		 * @description: 重新加载
		 * @param {String} model 单据id/附件清单
		 * @param {Boolean} loading 是否局部加载
		 */
		reload(model, loading) {
			this.clear();
			if (isEmpty(model)) {
				return;
			}
			if (Array.isArray(model)) {
				this.dataList = model;
			} else {
				this.getDetailList(model, loading);
			}
		},
		/**
		 * @description: 根据id获取清单数据
		 * @param {String} entityId 单据id
		 * @param {Boolean} loading 是否局部加载
		 */
		getDetailList(entityId, loading) {
			this.loading = loading;
			getAttachments(entityId, { pagination: false }, { loading: loading }).then(res => {
				this.loading = false;
				if (res != null && res.code === '00000') {
					this.isLoaded = true;
					if (this.dataList.length > 0) {
						this.dataList = res.rows.concat(this.dataList);
					} else {
						this.dataList = res.rows;
					}
				}
			});
		},
		/**
		 * @description: 清空清单
		 */
		clear() {
			this.dataList = [];
		},
		/**
		 * @description: 附件必填校验
		 */
		validate(msg) {
			const promise = new Promise((resolve, reject) => {
				if (this.required === false || this.dataList.length > 0) {
					resolve(true);
				} else {
					this.$message.error(msg ? msg : '请上传附件！');
					reject(false);
				}
			});
			return promise;
		},
		/**
		 * @description: 当前数据
		 */
		getDataList() {
			return this.dataList == null ? [] : this.dataList;
		},

		/**
		 * @description 追加附件
		 */
		addedAttachment(tempList) {
			if (tempList != null && isTypeof(tempList, 'array')) {
				tempList.forEach(item => {
					item.id = null;
					item.code = null;
					item.operate = 'ADD';
					this.dataList.push(item);
				});
			}
		},

		/**
		 * @description: 获取处理好的附件清单
		 */
		getStoreRows() {
			let attachments = this.dataList.filter(obj => obj.operate === 'ADD').concat(this.removed);
			return attachments.map(obj => ({ id: obj.id, ylcFileId: obj.ylcFile.id, operate: obj.operate }));
		},
		/**
		 * @description: 给表格每行数据增加下标
		 * @param {Object} row 行数据
		 * @param {Number} rowIndex 下标
		 */
		tableRowClassName({ row, rowIndex }) {
			row.rowIndex = rowIndex;
			if (this.multipleSelection.findIndex(obj => obj.rowIndex === rowIndex) > -1) {
				return 'current-row';
			}
		},
		/**
		 * @description: 点击表格行
		 * @param {Objject} row 选中行
		 */
		handleRowClick(row) {
			this.$refs['multipleTable'].clearSelection();
			this.$refs['multipleTable'].toggleRowSelection(row);
		},
		/**
		 * @description: 更改选中项
		 * @param {Array} selection 选中项
		 */
		handleSelectionChange(selection) {
			this.multipleSelection = selection;
		},
		/**
		 * @description: 指定表格批量删除
		 */
		handleDeleteRows() {
			this.multipleSelection.sort((a, b) => {
				return b.rowIndex - a.rowIndex;
			});
			for (let i = 0, len = this.multipleSelection.length; i < len; i++) {
				let row = this.multipleSelection[i];
				if (row.operate !== 'ADD') {
					row.operate = 'DELETE';
					this.removed.push(row);
				}
				this.dataList.splice(row.rowIndex, 1);
			}
		},
		/**
		 * @description: 文件上传
		 */
		handleUpload() {
			this.$refs['fileUploader'].open();
		},
		/**
		 * @description: 新增文件清单
		 * @param {Array} fileList 新增的文件列表
		 */
		handleAddFiles(fileList) {
			this.dataList = this.dataList.concat(fileList.map(obj => ({ ylcFile: obj, operate: 'ADD' })));
			if (this.dataList.length > this.max) {
				this.$message.warning('附件最多可上传' + this.max + '个！');
				this.dataList.splice(this.max);
			}
			this.$emit('complete', this.dataList);
		},
		/**
		 * @description: 文件预览
		 * @param {Object} file 文件信息
		 */
		handlePreview(file) {
			let type = this.getFileType(file.fileName);
			if (type === 'video' || type === 'audio' || type === 'image') {
				this.previewDialog.visible = true;
				this.previewDialog.fileType = type;
				this.previewDialog.filePath = file.httpFilePath;
			} else if (type === 'pdf' || type === 'txt') {
				window.open(file.httpFilePath);
			} else if (type === 'word' || type === 'excel' || type === 'ppt') {
				window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(file.httpFilePath)}`);
			} else {
				this.handleDownload(file);
			}
		},
		/**
		 * @description: 文件下载
		 * @param {String} file 文件
		 */
		handleDownload(file) {
			if (this.preventDownload !== file.fileName) {
				download(file);
			}
			this.preventDownload = file.fileName;
			setTimeout(() => {
				this.preventDownload = '';
			}, 1000);
		},
		/**
		 * @description: 根据文件名判断文件类型
		 * @param {String} fileName 文件名
		 */
		getFileType(fileName) {
			return getFileType(fileName);
		}
	}
};
</script>

<style lang="less" scoped>
:deep(.el-table) {
  .el-table__fixed-header-wrapper .cell,
  .el-table__header-wrapper .cell {
    font-family: @font-medium;
    color: @default-color;
  }
  .el-table__cell {
    padding: 6px 0;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
